var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navigation'),_c('Home'),_c('About'),_c('Presses'),_c('Photographies'),_c('Trailer'),_c('Teams'),_c('Kids'),_c('Donate'),_c('Screening'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }